import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';
import { DailyCountStatusComponent } from './daily-count-status/daily-count-status.component';
import { DailyCountWeeklyComponent } from './daily-count-weekly/daily-count-weekly.component';
import { BusinessDaysComponent } from './business-days/business-days.component';

@NgModule({
    declarations: [
        DailyCountStatusComponent
        , DailyCountWeeklyComponent
        , BusinessDaysComponent
    ],
    imports: [
        CommonModule
        , SharedModule
    ],
    exports: [
        DailyCountStatusComponent
        , DailyCountWeeklyComponent
        , BusinessDaysComponent
    ]
})
export class LandingModule { }
